$(document).ready(() => {
  var featuredProduct = $("[data-featured-products]");

  featuredProduct.each(function () {
    var self = $(this),
      productGrid = self.find(".products-grid"),
      gridItemWidth = productGrid.data("row"),
      hasRightSidebar = $(
        ".halo-product-content .pro-page [data-has-right-sidebar]"
      );

    if (productGrid.not(".slick-initialized")) {
      productGrid.slick({
        get slidesToShow() {
          if (hasRightSidebar.length) {
            return (this.slidesToShow = 5);
          } else {
            return (this.slidesToShow = productGrid.data("row"));
          }
        },

        get vertical() {
          if (
            productGrid.hasClass("verticle") &&
            $(".relate-verticle").length
          ) {
            return (this.vertical = true);
          } else {
            return (this.vertical = false);
          }
        },

        get slidesToScroll() {
          if (productGrid.hasClass("verticle")) {
            return (this.slidesToScroll = 1);
          } else {
            return (this.slidesToScroll = productGrid.data("row"));
          }
        },

        speed: 1000,
        infinite: false,

        get dots() {
          if (self.hasClass("has-banner")) {
            return (this.dots = true);
          } else {
            if (
              window.product_style == "supermarket" ||
              window.product_style == "surfup"
            ) {
              return (this.dots = true);
            } else {
              return (this.dots = false);
            }
          }
        },
        get nextArrow() {
          
            return (this.nextArrow =
              '<button type="button" class="slick-next" aria-label="Next"><i class="fa fa-angle-right"></i></button>');
          
        },
        get prevArrow() {
          
            return (this.prevArrow =
              '<button type="button" class="slick-prev" aria-label="prev"><i class="fa fa-angle-left"></i></button>');
          
        },
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              get slidesToShow() {              
                  return (this.slidesToShow = 5);      
              },
              get slidesToScroll() {
                  return (this.slidesToScroll = 5);
              },
            },
          },
          {
            breakpoint: 1200,
            settings: {
              dots: false,
              arrows: true,
              vertical: false,
              
              get slidesToShow() {              
                  return (this.slidesToShow = 5);      
              },
              get slidesToScroll() {
                  return (this.slidesToScroll = 5);
              },
            },
          },
          {
            breakpoint: 992,
            settings: {
              dots: false,
              arrows: true,
              vertical: false,
              get slidesToShow() {
                if (gridItemWidth >= 3) {
                  return (this.slidesToShow = 3);
                } else {
                  return (this.slidesToShow = 2);
                }
              },
              get slidesToScroll() {
                if (gridItemWidth >= 3) {
                  return (this.slidesToScroll = 3);
                } else {
                  return (this.slidesToScroll = 2);
                }
              },
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: false,
              arrows: true,
              vertical: false,
            },
          },
        ],
      });
    }
  });
});

    